<template>
    <div style="color:#666666;font-size: 12px;padding:25px">
        <div v-if="small">
            <div style="box-sizing: border-box; width:100%;max-width: 600px;margin:auto;">
                © Hive Properties 2019
            </div>
        </div>
        <div v-if="!small">
            <div style="box-sizing: border-box; width:100%;max-width: 1200px;margin:auto;">
                © Hive Properties 2019
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "Foot",
		computed: {
			small() {
				return this.$mq === 'sm';
			}
		}
	}
</script>

<style scoped>

</style>